import makeStyles from '@mui/styles/makeStyles';
import {amber, blue, green, lightBlue, red} from "@mui/material/colors";


export const MonitorStyle = makeStyles((theme) => ({
	main: {
		display: "grid",
		gridTemplateRows: "auto 1fr auto",
		height: "100vh",
	},
	emptyFooter: {
		paddingTop: theme.spacing(4),
	},
	mainContainer: {
		[theme.breakpoints.down('md')]: {
			maxWidth: "100vw",
		},
		marginTop: theme.spacing(2),
	},
	drawer: {
		width: 200,
		flexShrink: 0,
	},
	drawerPaper: {
		width: 200,
		paddingTop: 80,
	},
	treeview: {
		height: 240,
		flexGrow: 1,
		padding: theme.spacing(2)
	},
	mainContainerFlex: {
		maxWidth: "100%",
		marginTop: theme.spacing(2),
		flexWrap: "wrap",
		display: "flex",
		justifyContent: "center",
		margin: theme.spacing(0.5),
		padding: theme.spacing(0.5),
		listStyleType: "none",
		alignContent: "flex-start"
	},
	mainContainerTabs: {
		marginTop: theme.spacing(8)
	},
	backdrop: {
		zIndex: theme.zIndex.drawer + 1,
		color: '#fff',
	},
	paper: {
		height: "100%",
		width: "100%",
		padding: theme.spacing(2),
		position: "relative",
	},
	paperVaccini: {
		height: "100%",
		width: "100%",
		padding: theme.spacing(4),
		marginBottom: 180,
		position: "relative",
		[theme.breakpoints.down('sm')]: {
			padding: theme.spacing(1),
		},
	},
	paperHome: {
		padding: theme.spacing(2),
		margin: theme.spacing(2),
		marginLeft: "12%",
		marginRight: "12%",
		position: "relative",
		backgroundColor: theme.palette.mode === "light" ? "#e1f5fe" : "#018573",
	},
	titleHome: {
		color: theme.palette.mode === "light" ? theme.palette.primary.main : theme.palette.secondary.light
	},
	paperFlex: {
		flexWrap: "wrap",
		display: "flex",
		justifyContent: "center",
		height: "100%",
		width: "100%",
		padding: theme.spacing(2),
		position: "relative",
	},
	paperMarginTop: {
		height: "100%",
		width: "100%",
		padding: theme.spacing(2),
		position: "relative",
		marginTop: theme.spacing(3),
	},
	searchedPaper: {
		padding: theme.spacing(2),
		backgroundColor: lightBlue["50"]
	},
	pApertobs: {
		width: "100%",
		padding: theme.spacing(2),
		position: "relative",
		marginBottom: theme.spacing(2)
	},
	roundAppBar: {
		borderRadius: "4px",
	},
	paperPadding: {
		padding: theme.spacing(2),
		width: "100%",
	},
	questContainer: {
		display: "flex",
		flexDirection: "row",
		flexWrap: "wrap"
	},
	cardQuest: {
		display: "grid",
		gridTemplateRows: "1fr 50px",
		alignItems: "flex-start",
		width: 268,
		margin: theme.spacing(1),
		[theme.breakpoints.down('md')]: {
			width: "100%"
		},
	},
	loadingSkeleton: {
		margin: theme.spacing(1),
		borderRadius: "4px",
		[theme.breakpoints.down('md')]: {
			width: "100%"
		},
	},
	cardActionButton: {
		marginLeft: "auto"
	},
	subQuestion: {
		backgroundColor: theme.palette.mode === "light" ? "#e1f5fe" : "#01579b",
		marginLeft: theme.spacing(6),
		borderRadius: 12,
		[theme.breakpoints.down('md')]: {
			marginLeft: theme.spacing(2),
		},
	},
	subQuestionRadio: {
		backgroundColor: theme.palette.mode === "light" ? "#e1f5fe" : "#01579b",
		marginLeft: theme.spacing(6),
		borderRadius: 12,
		padding: theme.spacing(4, 0, 4, 4),
		[theme.breakpoints.down('md')]: {
			marginLeft: theme.spacing(2),
			width: "80%",
		},
	},
	subQuestionGroup: {
		backgroundColor: theme.palette.mode === "light" ? "#e1f5fe" : "#01579b",
		marginLeft: theme.spacing(6),
		[theme.breakpoints.down('md')]: {
			marginLeft: theme.spacing(2),
		},
	},
	subQuestionStart: {
		backgroundColor: theme.palette.mode === "light" ? "#e1f5fe" : "#01579b",
		marginLeft: theme.spacing(6),
		borderRadius: "12px 12px 0 0",
		[theme.breakpoints.down('md')]: {
			marginLeft: theme.spacing(2),
		},
	},
	subQuestionEnd: {
		backgroundColor: theme.palette.mode === "light" ? "#e1f5fe" : "#01579b",
		marginLeft: theme.spacing(6),
		borderRadius: "0 0 12px 12px ",
		[theme.breakpoints.down('md')]: {
			marginLeft: theme.spacing(2),
		},
	},
	subSubQuestionGroup: {
		backgroundColor: theme.palette.mode === "light" ? "#b3e5fc" : "#0d47a1",
		marginLeft: theme.spacing(8),
		[theme.breakpoints.down('md')]: {
			marginLeft: theme.spacing(3),
		},
	},
	subSubQuestion: {
		backgroundColor: theme.palette.mode === "light" ? "#b3e5fc" : "#0d47a1",
		marginLeft: theme.spacing(8),
		marginTop: theme.spacing(1),
		borderRadius: "12px",
		[theme.breakpoints.down('md')]: {
			marginLeft: theme.spacing(3),
		},
	},
	subSubQuestionStart: {
		backgroundColor: theme.palette.mode === "light" ? "#b3e5fc" : "#0d47a1",
		marginLeft: theme.spacing(8),
		marginTop: theme.spacing(1),
		borderRadius: "12px 12px 0 0",
		[theme.breakpoints.down('md')]: {
			marginLeft: theme.spacing(3),
		},
	},
	subSubQuestionEnd: {
		backgroundColor: theme.palette.mode === "light" ? "#b3e5fc" : "#0d47a1",
		marginLeft: theme.spacing(8),
		borderRadius: "0 0 12px 12px ",
		[theme.breakpoints.down('md')]: {
			marginLeft: theme.spacing(3),
		},
	},
	fab: {
		margin: theme.spacing(2),
		position: "fixed",
		bottom: 0,
		right: 0,
		zIndex: 10,
	},
	fabMail: {
		margin: theme.spacing(1),
	},
	extendedIconFab: {
		marginRight: theme.spacing(1),
	},
	helpFab: {
		position: "fixed",
		bottom: 20,
		left: 20,
		zIndex: 1000,
		backgroundColor: amber["A400"],
		"&:hover": {
			backgroundColor: amber["A700"],
		}
	},
	input: {
		textTransform: "uppercase",
	},
	capitalizeInput: {
		textTransform: "capitalize",
	},
	gridAnagrafica: {
		marginBottom: theme.spacing(1),
	},
	leftButton: {
		position: "absolute",
		right: theme.spacing(1),
		bottom: theme.spacing(1),
	},
	titleEdit: {
		display: "flex",
		flexDirection: "row",
		alignItems: "flex-start",
	},
	iconButtonEdit: {
		padding: "4px",
		marginLeft: "auto",
	},
	tabGrid: {
		padding: theme.spacing(1)
	},
	card: {
		width: 400,
		/*height: 280,*/
		margin: theme.spacing(1),
	},
	cardV2: {
		width: 280,
		/*height: 280,*/
		margin: theme.spacing(0.5),
	},
	actionAvatar: {
		width: 80,
		height: 80,
		[theme.breakpoints.down('sm')]: {
			width: 60,
			height: 60,
		},
	},
	actionAvatarV2: {
		width: 40,
		height: 40,
		[theme.breakpoints.down('sm')]: {
			width: 40,
			height: 40,
		},
	},
	cardAction: {
		height: "100%",
		display: "flex",
		alignItems: "flex-start"
	},
	pApertomponeDetail: {
		padding: theme.spacing(2)
	},
	parenteCard: {
		width: 300,
		margin: theme.spacing(1),
	},
	contentDetails: {
		padding: 0,
	},
	titleDetails: {
		backgroundColor: theme.palette.primary.main,
		color: "#FFF"
	},
	timelinePaper: {
		padding: theme.spacing(1),
	},
	greenDot: {
		backgroundColor: green[500],
		color: "#FFF"
	},
	yellowDot: {
		backgroundColor: amber[500],
		color: "#FFF"
	},
	connector: {
		backgroundColor: "#bdbdbd",
	},
	redDot: {
		backgroundColor: red[500],
		color: "#FFF"
	},
	blueDot: {
		backgroundColor: blue[500],
		color: "#FFF"
	},
	searchButton: {
		width: 300,
		float: "right"
	},
	heading: {
		fontSize: theme.typography.pxToRem(15),
		flexShrink: 0,
	},
	headingAccordion: {
		fontSize: theme.typography.pxToRem(15),
		flexBasis: '33.33%',
		flexShrink: 0,
	},
	secondaryHeading: {
		fontSize: theme.typography.pxToRem(15),
		color: theme.palette.text.secondary,
	},
	formControl: {
		margin: theme.spacing(3),
	},
	logoPiemonte: {
		width: 400,
		marginTop: "-20px",
		marginBottom: "-20px",
		[theme.breakpoints.down('lg')]: {
			width: 280,
		},
	},
	flexGrid: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
	},
	flexGridRow: {
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		justifyContent: "center",
		flexWrap: "wrap",
	},
	flexGridRowStart: {
		display: "flex",
		flexDirection: "row",
		alignItems: "flex-start",
		justifyContent: "flex-start",
		flexWrap: "wrap",
	},
	flexGridRientri: {
		display: "flex",
		flexDirection: "row",
		alignItems: "flex-end",
		justifyContent: "flex-end",
	},
	rientriButton: {
		margin: theme.spacing(1),
	},
	cardVacciniAction: {
		width: 264,
		height: 200,
		textAlign: "center",
		[theme.breakpoints.down('lg')]: {
			width: "100%",
		},
	},
	cardVaccini: {
		textAlign: "center",
		margin: theme.spacing(1),
		width: 264,
		borderRadius: 24,
		[theme.breakpoints.down('sm')]: {
			width: "100%",
		},
	},
	cardVacciniSelected: {
		textAlign: "center",
		padding: 0,
		margin: theme.spacing(1),
		width: 264,
		backgroundColor: theme.palette.secondary.light,
		color: "#000",
		borderRadius: 24,
		[theme.breakpoints.down('sm')]: {
			width: "100%",
		},
	},
	cardVacciniData: {
		padding: 0,
		margin: theme.spacing(2),
		width: 200,
		borderRadius: 24,
	},
	cardVacciniDataV2: {
		margin: theme.spacing(2),
		width: 100,
		borderRadius: 24,
	},
	cardVacciniDataSelected: {
		margin: theme.spacing(2),
		width: 200,
		borderRadius: 24,
		backgroundColor: theme.palette.secondary.light,
		color: "#000",
	},
	cardVacciniDataSelectedV2: {
		margin: theme.spacing(2),
		width: 100,
		borderRadius: 24,
		backgroundColor: theme.palette.secondary.light,
		color: "#000",
	},
	cardVacciniContent: {
		padding: 0,
		textAlign: "center"
	},
	vacciniMonthText: {
		backgroundColor: theme.palette.secondary.light,
		color: "#000",
		width: "100%"
	},
	cardVacciniOsp: {
		margin: theme.spacing(2),
		width: 300,
		height: 120,
		borderRadius: 24,
		textAlign: "center",
	},
	cardVacciniOspSelected: {
		margin: theme.spacing(2),
		width: 300,
		height: 120,
		borderRadius: 24,
		backgroundColor: theme.palette.secondary.light,
		textAlign: "center",
		color: "#000",
	},
	actionFullWidth: {
		height: "100%",
	},
	contentVacciniGrid: {
		display: "grid",
		gridTemplateRows: "80px auto 1fr",
		height: "100%"
	},
	centerContent: {
		display: "flex",
		alignItems: "center",
		flexDirection: "column",
	},
	green: {
		color: theme.palette.getContrastText(green[500]),
		backgroundColor: green[500],
		margin: theme.spacing(1),
		width: 50,
		height: 50
	},
	red: {
		color: theme.palette.getContrastText(red[500]),
		backgroundColor: red[500],
		margin: theme.spacing(1),
		width: 50,
		height: 50
	},
	amber: {
		color: theme.palette.getContrastText(amber[500]),
		backgroundColor: amber[500],
		margin: theme.spacing(1),
		width: 50,
		height: 50
	},
	roundCornerDialog: {
		borderRadius: 24,
	},

	timeSelectorButton: {
		margin: theme.spacing(1),
		backgroundColor: theme.palette.background.paper,
		fontSize: 24,
		fontWeight: "bolder",
		borderRadius: 24,
		color: theme.palette.mode === "light" ? "#000" : "#FFF",
		width: 120,
		height: 60,
		"&:hover": {
			border: "1px solid #64ffda",
			color: "#64ffda",
			backgroundColor: theme.palette.background.paper,
			boxShadow: "0px 2px 4px -1px rgba(100, 255, 218, 0.2), 0px 4px 5px 0px rgba(100, 255, 218, 0.14), 0px 1px 10px 0px rgba(100, 255, 218, 0.12)"
		}
	},
	timeSelectorButtonSelected: {
		margin: theme.spacing(1),
		backgroundColor: theme.palette.secondary.light,
		color: "#000",
		fontSize: 24,
		fontWeight: "bolder",
		borderRadius: 24,
		width: 120,
		height: 60,
		"&:hover": {
			border: "1px solid #64ffda",
			color: "#64ffda",
			backgroundColor: theme.palette.background.paper,
			boxShadow: "0px 2px 4px -1px rgba(100, 255, 218, 0.2), 0px 4px 5px 0px rgba(100, 255, 218, 0.14), 0px 1px 10px 0px rgba(100, 255, 218, 0.12)"
		}
	},
	timeRow: {
		display: "grid",
		gridTemplateColumns: "1fr 80px 1fr",
		alignItems: "center"
	},
	timeRowContainer: {
		display: "grid",
		gridTemplateRows: "50px auto"
	},
	timeFasciaIndicator: {
		textAlign: "center",
	},
	timeButtonContainer: {
		display: "flex",
		justifyContent: "center",
		flexWrap: "wrap",
	},
	finalChoosePaper: {
		zIndex: 2000,
		position: "fixed",
		bottom: 0,
		right: 0,
		left: 0,
		width: "100%",
		padding: theme.spacing(1.8),
		borderTop: "8px solid #64ffda"
	},
	vacciniTitleASL: {
		[theme.breakpoints.down('md')]: {
			padding: theme.spacing(1),
			fontSize: 40,
		},
	},
	vacciniTitle: {
		[theme.breakpoints.down('md')]: {
			padding: theme.spacing(1),
			fontSize: 28,
		},
	},
	leftRoundButton: {
		borderRadius: 24,
		paddingLeft: theme.spacing(1),
		paddingRight: theme.spacing(1),
		fontSize: 24,
		fontWeight: "bolder",
		margin: theme.spacing(1),
	},
	leftRoundButtonLight: {
		borderRadius: 24,
		paddingLeft: theme.spacing(1),
		paddingRight: theme.spacing(1),
		fontSize: 24,
		fontWeight: "bolder",
		margin: theme.spacing(1),
		backgroundColor: theme.palette.secondary.light
	},
	extendedIcon: {
		marginRight: theme.spacing(1),
	},
	fabRoot: {
		position: "fixed",
		bottom: 0,
		left: 0,
		'& > *': {
			margin: theme.spacing(2),
		},
		zIndex: 1000
	},
	amberFab: {
		backgroundColor: amber[500],
	},
	managerCard: {
		margin: theme.spacing(1),
	},
	managerContent: {
		height: 300,
		overflowY: "scroll",
		scrollbarWidth: "none", // Nasconde la scrollbar in Firefox
		"&::-webkit-scrollbar": {
			display: "none", // Nasconde la scrollbar in WebKit
		},
	},
	customCell: {
		border: "none",
		padding: 4
	},
	dayButton: {
		width: 80,
		height: 80,
		fontSize: 28,
		borderRadius: "50%"
	},
	addFileButton: {
		width: 160,
		height: 160,
		margin: theme.spacing(1),
		"&:hover": {
			boxShadow: "0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)",
			border: "none"
		},
	},
	fileCard: {
		display: "grid",
		gridTemplateRows: "1fr 48px",
		justifyItems: "center",
		width: 180,
		height: 180,
		margin: theme.spacing(1),
		[theme.breakpoints.down('md')]: {
			width: "100%"
		},
	},
	contentFileGrid: {
		display: "grid",
		gridTemplateRows: "64px 1fr"
	},
	fabContainer: {
		position: "fixed",
		right: 0,
		bottom: 0,
		padding: theme.spacing(1)
	},

	doseText: {
		backgroundColor: theme.palette.secondary.main,
		borderRadius: 24,
		width: 200,
		marginLeft: "auto",
		marginRight: "auto"
	},

	ticketAperto: {
		backgroundColor: red[500],
		color: "#FFF",
		borderRadius: 24,
		maxWidth: 300,
		textAlign: "center"
	},
	ticketPreso: {
		backgroundColor: amber[500],
		color: "#000",
		borderRadius: 24,
		maxWidth: 300,
		textAlign: "center"
	},
	ticketRisolto: {
		backgroundColor: green[500],
		color: "#FFF",
		borderRadius: 24,
		maxWidth: 300,
		textAlign: "center"
	},

	ticketGrid: {
		backgroundColor: "aliceblue",
		borderRadius: "8px"
	},
	ticketTitle: {
		textAlign: "center",
		fontSize: 40,
		color: blue[900],
		[theme.breakpoints.down('md')]: {
			fontSize: 32,
		},
	},
	ticketSubTitle: {
		textAlign: "center",
		fontSize: 32,
		color: blue[900],
		[theme.breakpoints.down('md')]: {
			fontSize: 22,
		},
	},
	ticketTitleSpan: {
		color: blue[600]
	},

	cardStp: {
		padding: 0,
		margin: theme.spacing(2),
		width: 200,
		borderRadius: 24,
		backgroundColor: theme.palette.secondary.light
	},
	cardStpSelected: {
		padding: 0,
		margin: theme.spacing(2),
		width: 200,
		borderRadius: 24,
		backgroundColor: blue[900],
		color: "#FFF",
	},

	cardCategoria: {
		padding: 0,
		margin: theme.spacing(2),
		width: 200,
		height: 160,
		borderRadius: 24,
	},
	cardCategoriaSelected: {
		padding: 0,
		margin: theme.spacing(2),
		width: 200,
		height: 300,
		borderRadius: 24,
	},
	mediaCategoria: {
		width: 60,
		height: 60,
		margin: "auto"
	},
	MuiAccordionRoot: {
		"&:before": {
			backgroundColor: "rgba(0,0,0,0)"
		}
	}
}));
